import { render } from "./DocsRow.vue?vue&type=template&id=3400fd74"
import script from "./DocsRow.vue?vue&type=script&lang=js"
export * from "./DocsRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__